// //正则

// // 3到12位（中文，字母，数字，下划线）账号
// export const ACC_REG = /^[a-zA-Z0-9_\u4E00-\u9FA5]{3,12}$/;

// // 3到12位（字母，数字，下划线）密码
// export const PWD_REG = /^[a-zA-Z0-9_]{3,12}$/;
export default {
    // 防抖
    _debounce(fn, delay = 200) {
      var timer;
      return function () {
        var th = this;
        var args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          timer = null;
          fn.apply(th, args);
        }, delay);
      };
    },
    // 节流
    _throttle(fn, interval = 200) {
      var last;
      var timer;
      return function () {
        var th = this;
        var args = arguments;
        var now = +new Date();
        if (last && now - last < interval) {
          clearTimeout(timer);
          timer = setTimeout(function () {
            last = now;
            fn.apply(th, args);
          }, interval);
        } else {
          last = now;
          fn.apply(th, args);
        }
      };
    },
  };